/* VIENEV · saklama kabı seçici: hacim ve fiyat çubuğu (otel fiyat çubuğu gibi), dağılım grafiği, hazır seçimler. */
(function () {
  var MIN_ML = 30, MAX_ML = 15000, SAYFA = 24;
  var NET = [10, 15, 20, 30, 50, 100, 150, 250, 500, 1000, 2000, 5000, 7000, 10000, 15000, 30000];
  var SAKLAMA = [
    { ad: 'Sos ve porsiyon', lo: 30, hi: 150 },
    { ad: 'Baharat boyu', lo: 200, hi: 600 },
    { ad: 'Kahvaltılık ve öğün', lo: 300, hi: 1100 },
    { ad: 'Erzak', lo: 1000, hi: 2200 },
    { ad: 'Un ve şeker', lo: 2500, hi: 8500 },
    { ad: 'Deterjan', lo: 3000, hi: 8000, ku: 'deterjan' }
  ];
  var HAZIR_KOL = {
    'baharatliklar': [{ ad: 'Tuzluk ve biberlik', lo: 20, hi: 150 }, { ad: 'Baharatlık', lo: 100, hi: 600 }, { ad: 'Büyük baharatlık', lo: 700, hi: 1200 }, { ad: 'Yağdanlık', lo: 200, hi: 1000, ku: 'yağ/sirke' }],
    'kahvaltilik': [{ ad: 'Sosluk', lo: 50, hi: 120 }, { ad: 'Kahvaltılık kap', lo: 200, hi: 650 }],
    'karistirma-kabi': [{ ad: 'Ölçü kabı', lo: 15, hi: 250 }, { ad: 'Karıştırma kabı', lo: 1000, hi: 7000 }],
    'kase': [{ ad: 'Sunum ve dondurma kasesi', lo: 100, hi: 250 }, { ad: 'Büyük kase', lo: 500, hi: 5000 }],
    'bardak': [{ ad: 'Espresso ve kahve', lo: 50, hi: 120 }, { ad: 'Çay bardağı ve kupa', lo: 150, hi: 450 }],
    'fincan-takimi': [{ ad: 'Espresso ve kahve', lo: 50, hi: 120 }, { ad: 'Çay ve kupa', lo: 150, hi: 450 }],
    'surahi-ve-karaf': [{ ad: 'Sürahi ve demlik', lo: 750, hi: 4000 }]
  };
  var HAZIR = SAKLAMA;
  // sofra kategorilerinde "kap" yerine "adet" (kase, bardak, fincan, sürahi)
  var ADET_KOL = ['kase', 'bardak', 'fincan-takimi', 'surahi-ve-karaf'];
  var BIRIM = 'kap';
  var KAP = [{ ad: 'Tek', a: 1, b: 1 }, { ad: '2–4', a: 2, b: 4 }, { ad: '5–8', a: 5, b: 8 }, { ad: '9–16', a: 9, b: 16 }, { ad: '17+', a: 17, b: 9999 }];
  var OLCEK_HEPSI = [20, 50, 100, 250, 500, 1000, 2000, 5000, 10000];
  var OLCEK = OLCEK_HEPSI;

  function ml2p(ml) { return Math.max(0, Math.min(1000, Math.round(1000 * (Math.log(ml) - Math.log(MIN_ML)) / (Math.log(MAX_ML) - Math.log(MIN_ML))))); }
  function p2ml(p) { return Math.exp(Math.log(MIN_ML) + (p / 1000) * (Math.log(MAX_ML) - Math.log(MIN_ML))); }
  function yuvarla(ml) {
    var adim = ml < 200 ? 5 : ml < 1000 ? 25 : ml < 5000 ? 100 : ml < 20000 ? 500 : 1000;
    return Math.min(MAX_ML, Math.max(MIN_ML, Math.round(ml / adim) * adim));
  }
  function hacimYaz(ml) {
    if (ml < 1000) return Math.round(ml) + ' ml';
    var l = ml / 1000; return (l >= 10 ? Math.round(l) : Math.round(l * 100) / 100).toString().replace('.', ',') + ' L';
  }
  function tl(kurus) { return (kurus / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; }
  function tlKisa(kurus) { return Math.round(kurus / 100).toLocaleString('tr-TR') + ' TL'; }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  var ARTI = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';

  function kur(kok) {
    if (kok.dataset.kuruldu) return; kok.dataset.kuruldu = '1';
    fetch(kok.dataset.veri).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (V) { calis(kok, V); }).catch(function () {});
  }

  function calis(kok, V) {
    var hepsi = V.u, sira = V.kol[kok.dataset.kol];
    var liste = sira ? sira.map(function (i) { return hepsi[i]; }) : hepsi.slice();
    // hacmi bilinmeyen ürün (lokumluk, kapaksız sunum vb.) listede kalır; hacim seçilince düşer
    liste = liste.filter(function (u) { return !!u; });
    if (!liste.some(function (u) { return u.p && u.p.length || u.vh; })) return;
    liste.forEach(function (u, i) {
      u._sira = i;
      var parcalar = (u.p || []).slice();
      if (u.vh) Object.keys(u.vh).forEach(function (k) { parcalar = parcalar.concat(u.vh[k]); });
      u._ml = parcalar.map(function (x) { return x[0]; });
      u._min = u._ml.length ? Math.min.apply(null, u._ml) : 1e9; u._max = u._ml.length ? Math.max.apply(null, u._ml) : -1;
    });
    // kategorinin hacim aralığına göre çubuk sınırları ve hazır seçimler
    var tumMl = []; liste.forEach(function (u) { tumMl = tumMl.concat(u._ml); });
    var enAz = Math.min.apply(null, tumMl), enCok = Math.max.apply(null, tumMl);
    MIN_ML = NET.filter(function (n) { return n <= enAz * 0.9; }).pop() || 10;
    MAX_ML = NET.filter(function (n) { return n >= enCok * 1.1; })[0] || 30000;
    OLCEK = OLCEK_HEPSI.filter(function (n) { return n > MIN_ML * 1.4 && n < MAX_ML / 1.3; });
    BIRIM = ADET_KOL.indexOf(kok.dataset.kol) >= 0 ? 'adet' : 'kap';
    var hacimli = liste.filter(function (u) { return u._ml.length; }).length;
    HAZIR = (HAZIR_KOL[kok.dataset.kol] || SAKLAMA).map(function (h) {
      return { ad: h.ad, lo: Math.max(h.lo, MIN_ML), hi: Math.min(h.hi, MAX_ML), ku: h.ku };
    }).filter(function (h) {
      if (h.lo <= MIN_ML && h.hi >= MAX_ML && !h.ku) return false;
      var n = liste.filter(function (u) { return (!h.ku || (u.ku || []).indexOf(h.ku) >= 0) && u._ml.some(function (m) { return m >= h.lo && m <= h.hi; }); }).length;
      return n >= 2 && n < hacimli;
    });
    var fMin = Math.min.apply(null, liste.map(function (u) { return u.f; }));
    var fMax = Math.max.apply(null, liste.map(function (u) { return u.f; }));
    function f2p(f) { return Math.round(1000 * Math.sqrt((f - fMin) / Math.max(1, fMax - fMin))); }
    function p2f(p) { return fMin + (fMax - fMin) * Math.pow(p / 1000, 2); }

    var S = { hLo: 0, hHi: 1000, fLo: 0, fHi: 1000, kap: {}, sekil: {}, kapak: {}, ku: null, sirala: 'oneri', goster: SAYFA };
    var q = new URLSearchParams(location.search);
    if (q.get('hacim')) { var hh = q.get('hacim').split('-'); S.hLo = ml2p(+hh[0] || MIN_ML); S.hHi = ml2p(+hh[1] || MAX_ML); }

    var panel = kok.querySelector('[data-hs-panel]'), ustSatir = kok.querySelector('[data-hs-ust-satir]');
    var izgara = kok.querySelector('[data-hs-izgara]'), daha = kok.querySelector('[data-hs-daha]');
    var hRay = kok.querySelector('[data-hs-ray="hacim"]'), fRay = kok.querySelector('[data-hs-ray="fiyat"]');
    var hAlt = hRay.querySelector('[data-hs-alt]'), hUst = hRay.querySelector('[data-hs-ust]');
    var fAlt = fRay.querySelector('[data-hs-alt]'), fUst = fRay.querySelector('[data-hs-ust]');
    panel.hidden = false; ustSatir.hidden = false;

    // Aşağı kayarken üstte yalnız uzun ml çubuğu (Ekmel 06/10)
    var yp = el('div', 'pb-hs__yapiskan'); yp.setAttribute('aria-hidden', 'true');
    yp.innerHTML = '<div class="pb-sar pb-hs__yic"><span class="pb-hs__yad">Hacim</span>' +
      '<div class="pb-hs__yray"><div class="pb-hs__ray" data-hs-ray="hacim2"><input type="range" min="0" max="1000" step="1" data-hs-alt aria-label="En küçük hacim" tabindex="-1"><input type="range" min="0" max="1000" step="1" data-hs-ust aria-label="En büyük hacim" tabindex="-1"></div><div class="pb-hs__olcek" data-hs-yolcek></div></div>' +
      '<b class="pb-hs__ydeger" data-hs-ydeger></b><span class="pb-hs__ysayi" data-hs-ysayi></span></div>';
    document.body.appendChild(yp);
    var h2Ray = yp.querySelector('[data-hs-ray="hacim2"]'), h2Alt = h2Ray.querySelector('[data-hs-alt]'), h2Ust = h2Ray.querySelector('[data-hs-ust]');
    OLCEK.forEach(function (ml) { var s2 = el('span', null, hacimYaz(ml)); s2.style.left = (ml2p(ml) / 10) + '%'; yp.querySelector('[data-hs-yolcek]').appendChild(s2); });
    function basAlti() {
      var b = 0;
      document.querySelectorAll('header-component, #header-component, .header-section').forEach(function (h) { var r = h.getBoundingClientRect(); if (r.bottom > b && r.top < 5) b = r.bottom; });
      return Math.max(0, Math.round(b));
    }
    function yapiskanBak() {
      var ust = basAlti(), pr = panel.getBoundingClientRect(), kr = kok.getBoundingClientRect();
      var goster = pr.bottom < ust && kr.bottom > ust + 160;
      yp.style.top = ust + 'px';
      if (goster !== yp.classList.contains('acik')) {
        yp.classList.toggle('acik', goster); yp.setAttribute('aria-hidden', goster ? 'false' : 'true');
        [h2Alt, h2Ust].forEach(function (i) { i.tabIndex = goster ? 0 : -1; });
      }
    }
    // dar ekranda üst üste binen ölçek yazılarını seyrelt (müşteri testi 06/10)
    function seyrelt() {
      kok.querySelectorAll('.pb-hs__olcek').forEach(seyreltKutu); yp.querySelectorAll('.pb-hs__olcek').forEach(seyreltKutu);
    }
    function seyreltKutu(kutu) {
      var son = -1e9;
      [].forEach.call(kutu.children, function (sp) {
        sp.style.visibility = '';
        var r = sp.getBoundingClientRect();
        if (!r.width) return;
        if (r.left < son + 6) { sp.style.visibility = 'hidden'; return; }
        son = r.right;
      });
    }
    window.addEventListener('resize', seyrelt);
    window.addEventListener('scroll', yapiskanBak, { passive: true });
    window.addEventListener('resize', yapiskanBak);

    // ölçek işaretleri
    var olcek = kok.querySelector('[data-hs-olcek]');
    OLCEK.forEach(function (ml) { var s = el('span', null, hacimYaz(ml)); s.style.left = (ml2p(ml) / 10) + '%'; olcek.appendChild(s); });
    var folcek = kok.querySelector('[data-hs-folcek]');
    [0, 250, 500, 750, 1000].forEach(function (p) { var s = el('span', null, tlKisa(p2f(p))); s.style.left = (p / 10) + '%'; folcek.appendChild(s); });

    // hazır seçimler
    var hazir = kok.querySelector('[data-hs-hazir]');
    HAZIR.forEach(function (h) {
      var b = el('button', 'pb-hs__cip', h.ad + ' · ' + hacimYaz(h.lo) + '–' + hacimYaz(h.hi)); b.type = 'button';
      b.addEventListener('click', function () {
        var acik = S.hLo === ml2p(h.lo) && S.hHi === ml2p(h.hi) && S.ku === (h.ku || null);
        S.hLo = acik ? 0 : ml2p(h.lo); S.hHi = acik ? 1000 : ml2p(h.hi); S.ku = acik ? null : (h.ku || null); S.goster = SAYFA; ciz();
      });
      b._h = h; hazir.appendChild(b);
    });

    // seçim düğmeleri
    function sayac(anahtar) { var c = {}; liste.forEach(function (u) { (u[anahtar] || []).forEach(function (x) { c[x] = (c[x] || 0) + 1; }); }); return c; }
    var secimKutulari = {};
    function secimKur(ad, degerler) {
      var kap = kok.querySelector('[data-hs-secim="' + ad + '"]'); secimKutulari[ad] = [];
      degerler.forEach(function (d) {
        var b = el('button', 'pb-hs__cip', d.ad || d); b.type = 'button'; b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () { var k = d.ad || d; S[ad][k] = !S[ad][k]; S.goster = SAYFA; ciz(); });
        b._k = d.ad || d; kap.appendChild(b); secimKutulari[ad].push(b);
      });
    }
    secimKur('kap', KAP);
    if (BIRIM !== 'kap') {
      var gEt = kok.querySelector('[data-hs-secim="kap"]').parentNode.querySelector('span'); if (gEt) gEt.textContent = 'Adet';
      var sOp = kok.querySelector('[data-hs-sirala] option[value="kap-basi"]'); if (sOp) sOp.textContent = 'Adet başı fiyat';
    }
    var sk = {}; liste.forEach(function (u) { if (u.s) sk[u.s] = (sk[u.s] || 0) + 1; });
    secimKur('sekil', Object.keys(sk).filter(function (k) { return sk[k] >= 3; }).sort(function (a, b) { return sk[b] - sk[a]; }));
    var kk = sayac('ka');
    secimKur('kapak', Object.keys(kk).filter(function (k) { return kk[k] >= 3; }).sort(function (a, b) { return kk[b] - kk[a]; }).slice(0, 6));

    function hacimUyar(u, lo, hi) { for (var i = 0; i < u._ml.length; i++) if (u._ml[i] >= lo && u._ml[i] <= hi) return true; return false; }
    function digerUyar(u, haric) {
      if (S.ku && (u.ku || []).indexOf(S.ku) < 0) return false;
      if (haric !== 'fiyat' && (u.f < p2f(S.fLo) - 1 || u.f > p2f(S.fHi) + 1)) return false;
      var ks = Object.keys(S.kap).filter(function (k) { return S.kap[k]; });
      if (ks.length && !ks.some(function (k) { var d = KAP.filter(function (x) { return x.ad === k; })[0]; return u.k >= d.a && u.k <= d.b; })) return false;
      var ss = Object.keys(S.sekil).filter(function (k) { return S.sekil[k]; });
      if (ss.length && ss.indexOf(u.s) < 0) return false;
      var ka = Object.keys(S.kapak).filter(function (k) { return S.kapak[k]; });
      if (ka.length && !ka.every(function (k) { return (u.ka || []).indexOf(k) >= 0; })) return false;
      if (haric !== 'hacim') { var lo = yuvarla(p2ml(S.hLo)), hi = yuvarla(p2ml(S.hHi)); if (S.hLo > 0 || S.hHi < 1000) { if (!hacimUyar(u, lo * 0.999, hi * 1.001)) return false; } }
      return true;
    }

    function grafik(kutu, degerler, aralik, p2deger, sec) {
      var N = 40, say = new Array(N).fill(0);
      degerler.forEach(function (v) { var i = Math.min(N - 1, Math.max(0, Math.floor(v / 1000 * N))); say[i]++; });
      var en = Math.max.apply(null, say) || 1;
      if (!kutu._cubuklar) { kutu._cubuklar = []; for (var i = 0; i < N; i++) { var b = el('i'); kutu.appendChild(b); kutu._cubuklar.push(b); } }
      kutu._cubuklar.forEach(function (b, i) {
        b.style.height = (say[i] ? Math.max(6, Math.round(100 * say[i] / en)) : 0) + '%';
        var orta = (i + 0.5) * 1000 / N; b.className = orta >= sec[0] && orta <= sec[1] ? 'acik' : '';
      });
    }

    function kart(u) {
      var d = el('div'), k = el('div', 'pb-kart');
      var lo = yuvarla(p2ml(S.hLo)) * 0.999, hi = yuvarla(p2ml(S.hHi)) * 1.001, filtreli = S.hLo > 0 || S.hHi < 1000;
      var a = el('a', 'pb-kart__gorsel'); a.href = u.url; a.tabIndex = -1; a.setAttribute('aria-hidden', 'true');
      if (u.g1) { var i1 = el('img', 'pb-kart__img'); i1.loading = 'lazy'; i1.src = u.g1 + (u.g1.indexOf('?') < 0 ? '?' : '&') + 'width=600'; i1.alt = u.ad; a.appendChild(i1); }
      if (u.g2) { var i2 = el('img', 'pb-kart__img pb-kart__img--2'); i2.loading = 'lazy'; i2.src = u.g2 + (u.g2.indexOf('?') < 0 ? '?' : '&') + 'width=600'; i2.alt = ''; a.appendChild(i2); }
      k.appendChild(a);
      var ad = el('a', 'pb-kart__ad', u.ad); ad.href = u.url; k.appendChild(ad);
      var boy = el('div', 'pb-hs__boylar');
      (u.p || []).slice(0, 4).forEach(function (x, i) {
        var s = el(filtreli && x[0] >= lo && x[0] <= hi ? 'b' : 'span', null, (x[1] > 1 ? x[1] + '×' : '') + hacimYaz(x[0]));
        if (i) boy.appendChild(document.createTextNode(' · ')); boy.appendChild(s);
      });
      if ((u.p || []).length > 4) boy.appendChild(document.createTextNode(' · +' + (u.p.length - 4)));
      if (!u.p && u.vh) boy.textContent = Object.keys(u.vh).length + ' boy seçeneği';
      k.appendChild(boy);
      if (filtreli && u.p && u.k > 1) {
        var uyan = 0; u.p.forEach(function (x) { if (x[0] >= lo && x[0] <= hi) uyan += x[1]; });
        if (uyan > 0 && uyan < u.k) k.appendChild(el('div', 'pb-hs__rozet', 'Bu aralıkta: ' + uyan + ' / ' + u.k + ' ' + BIRIM));
      }
      var alt = el('div', 'pb-kart__alt'), fy = el('div', 'pb-kart__fiyat');
      if (u.e && u.e > u.f) { var es = el('span', 'pb-kart__eski'); es.innerHTML = '<s>' + tl(u.e) + '</s>'; fy.appendChild(es); }
      var yf = el('span', 'pb-kart__yeni', tl(u.f)); if (u.fv) yf.appendChild(el('small', 'pb-kart__baslayan', "'den başlayan")); fy.appendChild(yf);
      if (u.k > 1) fy.appendChild(el('span', 'pb-hs__kapbasi', BIRIM + ' başı ' + tl(Math.round(u.f / u.k))));
      alt.appendChild(fy);
      var dg;
      if (u.v) { dg = el('button', 'pb-ekle'); dg.type = 'button'; dg.setAttribute('data-pb-sepete', ''); dg.dataset.idler = String(u.v); }
      else { dg = el('a', 'pb-ekle'); dg.href = u.url; }
      dg.setAttribute('aria-label', u.ad + (u.v ? ' sepete ekle' : ' seçenekleri')); dg.innerHTML = ARTI;
      alt.appendChild(dg); k.appendChild(alt); d.appendChild(k);
      return d;
    }

    var bekle = false;
    function ciz() {
      if (document.hidden) { ciz2(); return; }
      if (bekle) return; bekle = true;
      requestAnimationFrame(function () { bekle = false; ciz2(); });
      setTimeout(function () { if (bekle) { bekle = false; ciz2(); } }, 120);
    }
    function ciz2() {
      if (S.hLo > S.hHi - 10) S.hLo = Math.max(0, S.hHi - 10);
      if (S.fLo > S.fHi - 10) S.fLo = Math.max(0, S.fHi - 10);
      hAlt.value = S.hLo; hUst.value = S.hHi; fAlt.value = S.fLo; fUst.value = S.fHi;
      hRay.style.setProperty('--a', S.hLo / 10 + '%'); hRay.style.setProperty('--b', S.hHi / 10 + '%');
      h2Alt.value = S.hLo; h2Ust.value = S.hHi;
      h2Ray.style.setProperty('--a', S.hLo / 10 + '%'); h2Ray.style.setProperty('--b', S.hHi / 10 + '%');
      fRay.style.setProperty('--a', S.fLo / 10 + '%'); fRay.style.setProperty('--b', S.fHi / 10 + '%');
      var hTum = S.hLo === 0 && S.hHi === 1000, fTum = S.fLo === 0 && S.fHi === 1000;
      kok.querySelector('[data-hs-hacim-yazi]').textContent = hTum ? 'Tümü' : hacimYaz(yuvarla(p2ml(S.hLo))) + ' – ' + hacimYaz(yuvarla(p2ml(S.hHi)));
      kok.querySelector('[data-hs-fiyat-yazi]').textContent = fTum ? 'Tümü' : tlKisa(p2f(S.fLo)) + ' – ' + tlKisa(p2f(S.fHi));
      hazir.querySelectorAll('.pb-hs__cip').forEach(function (b) { b.setAttribute('aria-pressed', S.hLo === ml2p(b._h.lo) && S.hHi === ml2p(b._h.hi) && S.ku === (b._h.ku || null) ? 'true' : 'false'); });
      Object.keys(secimKutulari).forEach(function (ad) { secimKutulari[ad].forEach(function (b) { b.setAttribute('aria-pressed', S[ad][b._k] ? 'true' : 'false'); }); });
      // dağılım grafikleri: diğer seçimler uygulanmış hâlde
      var hd = []; liste.forEach(function (u) { if (digerUyar(u, 'hacim')) u._ml.forEach(function (m) { hd.push(ml2p(Math.min(MAX_ML, Math.max(MIN_ML, m)))); }); });
      grafik(kok.querySelector('[data-hs-hacim-grafik]'), hd, null, null, [S.hLo, S.hHi]);
      var fd = []; liste.forEach(function (u) { if (digerUyar(u, 'fiyat')) fd.push(f2p(u.f)); });
      grafik(kok.querySelector('[data-hs-fiyat-grafik]'), fd, null, null, [S.fLo, S.fHi]);
      // sonuç
      var sonuc = liste.filter(function (u) { return digerUyar(u); });
      var sr = S.sirala;
      sonuc.sort(function (a, b) {
        if (sr === 'fiyat-artan') return a.f - b.f;
        if (sr === 'fiyat-azalan') return b.f - a.f;
        if (sr === 'hacim-artan') return a._min - b._min || a._sira - b._sira;
        if (sr === 'hacim-azalan') return b._max - a._max || a._sira - b._sira;
        if (sr === 'kap-basi') return a.f / a.k - b.f / b.k;
        return a._sira - b._sira;
      });
      kok.querySelector('[data-hs-sayi]').textContent = sonuc.length + ' ürün';
      yp.querySelector('[data-hs-ysayi]').textContent = sonuc.length + ' ürün';
      yp.querySelector('[data-hs-ydeger]').textContent = kok.querySelector('[data-hs-hacim-yazi]').textContent;
      var secili = !hTum || !fTum || !!S.ku || ['kap', 'sekil', 'kapak'].some(function (ad) { return Object.keys(S[ad]).some(function (k) { return S[ad][k]; }); });
      kok.querySelector('[data-hs-temizle]').hidden = !secili;
      izgara.innerHTML = '';
      if (!sonuc.length) izgara.appendChild(el('p', 'pb-hs__bos', 'Bu seçimlere uyan ürün yok. Çubuğu biraz genişletin.'));
      sonuc.slice(0, S.goster).forEach(function (u) { izgara.appendChild(kart(u)); });
      daha.hidden = sonuc.length <= S.goster;
      daha.textContent = 'Daha fazla göster (' + (sonuc.length - S.goster) + ')';
      try {
        var url = new URL(location.href);
        if (hTum) url.searchParams.delete('hacim'); else url.searchParams.set('hacim', yuvarla(p2ml(S.hLo)) + '-' + yuvarla(p2ml(S.hHi)));
        history.replaceState(null, '', url);
      } catch (e) {}
    }

    hAlt.addEventListener('input', function () { S.ku = null; S.hLo = Math.min(+hAlt.value, S.hHi - 10); S.goster = SAYFA; ciz(); });
    hUst.addEventListener('input', function () { S.ku = null; S.hHi = Math.max(+hUst.value, S.hLo + 10); S.goster = SAYFA; ciz(); });
    h2Alt.addEventListener('input', function () { S.ku = null; S.hLo = Math.min(+h2Alt.value, S.hHi - 10); S.goster = SAYFA; ciz(); });
    h2Ust.addEventListener('input', function () { S.ku = null; S.hHi = Math.max(+h2Ust.value, S.hLo + 10); S.goster = SAYFA; ciz(); });
    fAlt.addEventListener('input', function () { S.fLo = Math.min(+fAlt.value, S.fHi - 10); S.goster = SAYFA; ciz(); });
    fUst.addEventListener('input', function () { S.fHi = Math.max(+fUst.value, S.fLo + 10); S.goster = SAYFA; ciz(); });
    kok.querySelector('[data-hs-sirala]').addEventListener('change', function (e) { S.sirala = e.target.value; ciz(); });
    kok.querySelector('[data-hs-temizle]').addEventListener('click', function () { S.hLo = 0; S.hHi = 1000; S.fLo = 0; S.fHi = 1000; S.kap = {}; S.sekil = {}; S.kapak = {}; S.ku = null; S.goster = SAYFA; ciz(); });
    daha.addEventListener('click', function () { S.goster += SAYFA; ciz(); });
    ciz2(); yapiskanBak(); seyrelt();
    var ilkAcik = false;
    window.addEventListener('scroll', function () { if (!ilkAcik && yp.classList.contains('acik')) { ilkAcik = true; seyreltKutu(yp.querySelector('.pb-hs__olcek')); } }, { passive: true });
  }

  function hepsi() { document.querySelectorAll('[data-pb-hs]').forEach(kur); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hepsi); else hepsi();
  document.addEventListener('shopify:section:load', hepsi);
})();
